// extracted by mini-css-extract-plugin
export var pageHeader = "pageHeader-module--pageHeader--OC2fM";